// Client for /api/history — the caller's own chat log, 20 per page.
import { supabase } from '../lib/supabaseClient';

export async function fetchHistory(page = 1) {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  if (!token) throw new Error('Please log in first.');

  const res = await fetch(`/api/history?page=${page}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  let json = null;
  try {
    json = await res.json();
  } catch {
    // non-JSON body — handled by the generic error below
  }
  if (!res.ok) throw new Error(json?.error || `Request failed (${res.status})`);
  return json; // { items, page, page_size, total }
}
